import { render } from "./Kv2.vue?vue&type=template&id=1f946e9a&scoped=true"
import script from "./Kv2.vue?vue&type=script&lang=js"
export * from "./Kv2.vue?vue&type=script&lang=js"

import "./Kv2.vue?vue&type=style&index=0&id=1f946e9a&scoped=true&lang=scss"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f946e9a"]])

export default __exports__